import Abouthome from "../pages/Abouthome";
import CarsSection from "../pages/CarsSection";
import LogoSlider from "../pages/LogoSlider";
import NewsSection from "../pages/NewsSection";
import ServicesSection from "../pages/ServicesSection";
import TestimonialSection from "../pages/TestimonialSection";
import Carousel from "./Carousel";


function Home() {



  return (
    
    <div>



    <Carousel/>
    <Abouthome/>
    <CarsSection/>
    <ServicesSection/>
    <TestimonialSection/>
    <NewsSection/>
    <LogoSlider/>
      </div>

    

  );
}
export default Home;